import * as React from 'react';
import { createSubcomponent } from '@workday/canvas-kit-react/common';
import { Card } from '@workday/canvas-kit-react/card';
import { usePopupHeading, usePopupModel } from './hooks';
export const PopupHeading = createSubcomponent('h2')({
    displayName: 'Popup.Heading',
    modelHook: usePopupModel,
    elemPropsHook: usePopupHeading,
})(({ children, ...elemProps }, Element) => {
    return (React.createElement(Card.Heading, Object.assign({ as: Element, marginBottom: "xxs", padding: "xxs" }, elemProps), children));
});
